export type SceneLoadingState = "loading" | "error";

type SceneLoadingProps = {
  state: SceneLoadingState;
};

export function SceneLoading({ state }: SceneLoadingProps) {
  return (
    <div className="scene-loading" role={state === "error" ? "alert" : "status"}>
      <div className="scene-loading-box">
        <div className="scene-loading-mark" />
        <div className="scene-loading-title">
          {state === "error" ? "模型加载失败" : "模型加载中"}
        </div>
        <div className="scene-loading-detail">
          {state === "error" ? "请稍后刷新重试" : "正在准备 3D 场景"}
        </div>
      </div>
    </div>
  );
}
